import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Validates if a phone number is in E.164 format
 * E.164 format: starts with +, followed by 1-15 digits
 */
export function isValidPhoneNumber(phone: string | null | undefined): boolean {
  if (!phone) return false;

  const trimmed = phone.trim();
  // E.164 format: starts with +, followed by 1-15 digits
  const e164Pattern = /^\+[1-9]\d{1,14}$/;
  return e164Pattern.test(trimmed);
}

/**
 * Gets a human-readable reason why phone number is invalid
 */
export function getPhoneValidationReason(phone: string | null | undefined): string {
  if (!phone) {
    return "No mobile number available for this debtor";
  }

  const trimmed = phone.trim();

  if (!trimmed.startsWith("+")) {
    return "Mobile number must be in E.164 format (e.g., +447911123456)";
  }

  if (trimmed.length > 1 && trimmed[1] === "0") {
    return "Country code cannot start with 0 (e.g., use +44 not +044)";
  }

  const digitsOnly = trimmed.slice(1);
  if (/[^\d]/.test(digitsOnly)) {
    return "Mobile number must contain only digits after the + prefix";
  }

  if (!isValidPhoneNumber(phone)) {
    return "Mobile number must be between 2 and 15 digits (E.164 format)";
  }

  return "";
}
